export default __webpack_public_path__ + "static/liner_drone-5b391ce710fe4051e5fd517ecffbc29b.jpg";